import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { useContext } from 'react';
import { CraftIdentityContext } from "pages/CraftIdentity";
import useEffectOnce from 'hooks/useEffectOnce';

const CraftingIdentityPopupSelect = ({ isVisible, setIsVisible, activeName, setActiveName }) => {

  const { matches, setSelectedName } = useContext(CraftIdentityContext);

  const selectHandle = (item) => {
    setActiveName(item.name);
    setSelectedName(item);
    setIsVisible(false)
  }

  useEffectOnce(() => {
    if (matches.length === 1) {
      setActiveName(matches[0].name);
      setSelectedName(matches[0]);
    }
  })

  return (
    <div className="crafting-popup__select">
      <button
        type='button'
        className={`crafting-popup__select-button ${isVisible ? 'active' : ''}`}
        onClick={() => setIsVisible(!isVisible)}
      >
        {activeName}
      </button>
      {
        isVisible ?
          <Swiper
            direction={'vertical'}
            slidesPerView={'auto'}
            freeMode={true}
            mousewheel={{
        releaseOnEdges: true
      }}
            modules={[FreeMode, Mousewheel]}
          >
            <SwiperSlide>
              <ul className="crafting-popup__select-list">
                {
                  matches.map((item) => (
                    <li
                      key={item.id}
                      className='crafting-popup__select-list-item'
                      onClick={() => selectHandle(item)}
                    >
                      {item.name}
                    </li>
                  ))
                }
              </ul>
            </SwiperSlide>
          </Swiper>
          : null
      }
    </div>
  )
}

export default CraftingIdentityPopupSelect;
